import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import UserActions from "../../store/user/Actions";
import { connect } from "react-redux";
import Images from "../../images";
import CancelIcon from "@mui/icons-material/Cancel";
import "../CommonItems/CommonStyle.css";
import "../CommonItems/ActivityList.css";
import ActivityItem from "./ActivityItem";
import ActivityItemSkeleton from "./ActivityItemSkeleton";
import { Column, Grid } from "carbon-components-react";
import {
  SMART_PAPER,
  SMART_LABEL,
  SMART_TILE,
  GET_ACTIVITY,
} from "../../constants";
import { VolumeUpFilled, VolumeMuteFilled } from "@carbon/icons-react";
import EmptyScreen from "./EmptyScreen";
function ActivityList(props) {
  const history = useHistory();
  const { activityListData, onCloseClick, internalLoading } = props;
  const {
    selectedCourseName,
    selectedLessonName,
    selectedTargetDate,
    saveMuteStatus,
  } = props;
  const { user, lessonUnitDetails, muteStatus, muteClicked, token } = props; // from redux state
  const {
    setPreviousExerciseList,
    setExerciseList,
    getActivityForStudent,
    setShowHideLoader,
    refreshToken,
    userToken,
    showOrHideToaster,
  } = props; // from redux state

  const [saveUserErrorCount, setSaveUserErrorCount] = useState(0);
  const [selectedContentID, setSelectedContentID] = useState(0);
  const [dataLoading, setDataLoading] = useState(false);

  function startLesson(index) {
    setShowHideLoader(true);
    let exerciseList = [
      ...lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult,
    ];
    const prevEx = exerciseList.slice(0, index + 1);
    //  const currentExercise = prevEx[prevEx.length - 1];
    const currentExercise = exerciseList[index];
    const { ContentID, AppName } = currentExercise;

    setPreviousExerciseList(prevEx, () => {
      console.log("previous exercise updated");
    });
    setExerciseList(exerciseList.slice(index + 1), () => {
      setSelectedContentID(ContentID);
      navigateToExercise(ContentID, token);
    });
  }

  function navigateToExercise(contentID, tokenData) {
    setDataLoading(true);
    getActivityForStudent(
      user.LoginID,
      contentID,
      tokenData,
      (activityDataResponse) => {
        if (activityDataResponse.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setDataLoading(false);
            history.push("/Activity");
          }, 2000);
        } else if (activityDataResponse.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_ACTIVITY);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
          }
        } else {
          showOrHideToaster(true, activityDataResponse.StatusMessage, "error");
        }
      }
    );
  }

  function refreshTokenCall(apiCall) {
    refreshToken(token, (tokenResponse) => {
      if (tokenResponse.Success) {
        if (apiCall === GET_ACTIVITY) {
          navigateToExercise(selectedContentID, tokenResponse.Token);
        }
        userToken(tokenResponse.Token);
        setSaveUserErrorCount(1);
      } else {
        showOrHideToaster(true, "Server failed! Please try again.", "error");
        setSaveUserErrorCount(0);
        setShowHideLoader(false);
      }
    });
  }

  const activityItemColorOdd = [
    { image: Images.activity_thumbnail, color: "#fd1999" },
    { image: Images.activity_thumbnail, color: "#FF9E2D" },
  ];
  const activityItemColorEven = [
    { image: Images.activity_thumbnail, color: "#3380F7" },
    { image: Images.activity_thumbnail, color: "#3EC986" },
  ];

  function getRandomItem(arr) {
    // get random index value
    const randomIndex = Math.floor(Math.random() * arr.length);
    // get random item
    const item = arr[randomIndex];
    return item;
  }

  function renderLessonsData() {
    if (activityListData && activityListData.length > 0) {
      return (
        <Grid className="home-grid-style">
          {activityListData.length > 0 &&
            activityListData.map((activityDetail, index) => {
              return (
                <Column
                  key={"activityList-" + index}
                  className="activity-column-style"
                  lg={4}
                  md={4}
                  sm={4}
                  onClick={() => {
                    startLesson(index);
                  }}
                >
                  <ActivityItem
                    activityName={activityDetail.ContentName}
                    activityStatus={activityDetail.Status}
                    activityColor={
                      index % 2
                        ? getRandomItem(activityItemColorEven)
                        : getRandomItem(activityItemColorOdd)
                    }
                    activityTypeIcon={
                      activityDetail.AppName === SMART_LABEL
                        ? Images.smart_label_icon
                        : activityDetail.AppName === SMART_PAPER
                        ? Images.smart_paper_icon
                        : activityDetail.AppName === SMART_TILE
                        ? Images.smart_tile_icon
                        : Images.smart_slide_icon
                    }
                    activityType={activityDetail.ActivityType}
                  />
                </Column>
              );
            })}
        </Grid>
      );
    } else {
      return (
        <EmptyScreen
          imageAnime={Images.empty_anim_3}
          emptyMessage={"Looks like you don’t have any actvity to complete"}
        />
      );
    }
  }

  function renderLessonDataSkeleton() {
    return (
      <Grid className="home-grid-style" condensed>
        {Array.from(Array(8)).map((assignment, index) => {
          return (
            <Column
              key={"assensmentSkeleton" + index}
              className="activity-column-style"
              lg={4}
              md={4}
              sm={4}
            >
              <ActivityItemSkeleton />
            </Column>
          );
        })}
      </Grid>
    );
  }

  return (
    <div className="activity-list-main">
      <div className="activity-pop-up-container">
        <div className="popup-header1">
          <CancelIcon
            style={{
              cursor: "pointer",
              marginRight: "1%",
              color: "#585858",
            }}
            onClick={() => {
              onCloseClick();
            }}
          />
        </div>
        <div className="popup-lesson-details-container">
          <div className="lesson-details-thumb-cont">
            <img
              src={Images.lesson_thumbnail}
              alt="logo"
              style={{
                // width: "80%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
          <div className="lesson-details-label-cont">
            <p className="common-lesson-name">{selectedLessonName}</p>
            <p className="common-course-name">{selectedCourseName}</p>
            <p className="common-due-date">{selectedTargetDate}</p>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: "12%",
            display: "flex",
            backgroundColor: "white",
            padding: "2%",
          }}
        >
          <p className="common-lesson-desc">
            {activityListData.length > 0 && activityListData[0].Description}
          </p>
        </div>
        <div
          style={{
            width: "100%",
            height: "63%",
            display: "flex",
            backgroundColor: "white",
            borderBottomLeftRadius: "15px",
            borderBottomRightRadius: "15px",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "98%",
              height: "100%",
              backgroundColor: "#f6f6f6",
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "10%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderColor: "#d9d9d9",
                borderWidth: "1px",
                borderBottomStyle: "solid",
                padding: "0px 10px",
              }}
            >
              <p
                className="common-lesson-name text-black text-18 text-width-0"
                style={{ width: "100%", justifyContent: "center" }}
              >
                Activities
              </p>
              {/* <div style={{ padding: "10px" }}>
                {muteStatus ? (
                  <Button
                    className="mute-icon-act"
                    hasIconOnly
                    iconDescription={"Unmute"}
                    renderIcon={VolumeMuteFilled}
                    tooltipAlignment="center"
                    tooltipPosition="bottom"
                    // disabled={disableClick ? true : false}
                    onClick={() => {
                      if (muteStatus) {
                        saveMuteStatus(false, true);
                      } else {
                        saveMuteStatus(true, true);
                      }
                    }}
                  />
                ) : (
                  <Button
                    className="mute-icon-act"
                    hasIconOnly
                    iconDescription={"Mute"}
                    renderIcon={VolumeUpFilled}
                    tooltipAlignment="center"
                    tooltipPosition="bottom"
                    // disabled={disableClick ? true : false}
                    onClick={() => {
                      if (muteStatus) {
                        saveMuteStatus(false, true);
                      } else {
                        saveMuteStatus(true, true);
                      }
                    }}
                  />
                )}
              </div> */}
              <div
                style={{
                  borderRadius: "100%",
                  backgroundColor: "#6644ff",
                  padding: "5px",
                }}
                onClick={() => {
                  if (muteStatus) {
                    saveMuteStatus(false, true);
                  } else {
                    saveMuteStatus(true, true);
                  }
                }}
              >
                {muteStatus ? (
                  <VolumeMuteFilled
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "#ffffff",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <VolumeUpFilled
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "#ffffff",
                      cursor: "pointer",
                    }}
                  />
                )}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: "90%",
                overflowX: "hidden",
                overflowY: "auto",
                padding: "16px 8px 16px 16px",
              }}
            >
              {internalLoading || dataLoading
                ? renderLessonDataSkeleton()
                : renderLessonsData()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
  lessonUnitDetails: state.user.lessonUnitDetails,
  muteStatus: state.user.muteStatus,
  muteClicked: state.user.muteClicked,
});

const mapDispatchToProps = (dispatch) => ({
  setShowHideLoader: (status) =>
    dispatch(UserActions.setShowHideLoader(status)),
  getActivityForStudent: (studentID, contentID, token, successFn) =>
    dispatch(
      UserActions.getActivityForStudent(studentID, contentID, token, successFn)
    ),
  setExerciseList: (exerciseList, successFn) =>
    dispatch(UserActions.setExerciseList(exerciseList, successFn)),
  setPreviousExerciseList: (exerciseList, successFn) =>
    dispatch(UserActions.setPreviousExerciseList(exerciseList, successFn)),
  refreshToken: (tokenData, successFn) =>
    dispatch(UserActions.refreshToken(tokenData, successFn)),
  userToken: (token) => dispatch(UserActions.userToken(token)),
  showOrHideToaster: (showToastModal, toastMessageText, toastType) =>
    dispatch(
      UserActions.showOrHideToaster(showToastModal, toastMessageText, toastType)
    ),
  saveMuteStatus: (muteStatus, muteClicked) =>
    dispatch(UserActions.saveMuteStatus(muteStatus, muteClicked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityList);
